import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ref'
})
export class RefPipe implements PipeTransform {

  transform(id: string, field: string, objs: any[]): string {
   
    var ret = ''
    
    objs.filter(o => o.id == id).forEach(o => {
      ret += o[field]
    })

    return ret

  }

}
